/*eslint-disable*/
import dayjs from "dayjs";
import {LOCALES } from "../constants/general";
import { DISABLED_BULK_FOR_TENANTS } from "../pages/createUser/createUser.constants";

export const getFirstName = (user={}) => {
    const firstName  = user.name?.givenName
    return firstName || '';
};

export const getLastName = (user={}) => {
    const lastName  = user.name?.familyName
    return lastName || '';
}

export const isRestrictedTenant = () => {
    const tenant = localStorage.getItem('tenant'); 
    const restrictedTenant = DISABLED_BULK_FOR_TENANTS.includes(tenant);
    return restrictedTenant;
};

export const getFullName = user => `${getFirstName(user)} ${getLastName(user)}`

export const getEmail = (user={}) => user.emails?.[0]?.value

export const getPhone = (user={}) => user.phoneNumbers?.[0]?.value

export const getCountry = (user={}) => user.addresses?.[0]?.country

export const getGuid = (user={}) => user.id

export const getCountryLabel = (countries,user) => {
    const countryValue = getCountry(user);
    const selectedCountry = countries.find(country => country?.code == countryValue);
    return `${selectedCountry?.country} (${countryValue})`  || '';
}

export const getStatus = (user={}) => {
    return user.status
}
export const getLocale = (user={}) => user.locale

export const getLocaleLabel = (user) => {
    const localeValue = getLocale(user);
    const selectedLocale = LOCALES.find(locale => locale?.value == localeValue);
    return selectedLocale?.label || '';
}

export const isActiveUser = user => user.status === 'ACTIVE';

export const isNewUser = user => isActiveUser(user) && user?.meta?.lastLogin === null;

export const isPartiallyActive = (user) => {
    const mfaResources = user?.mfaResources || [];
    return mfaResources.length === 0 || !mfaResources.includes('email');
}

export const shouldEnableForgotPassword = user => isActiveUser(user) && !isNewUser(user) && !isRestrictedTenant() && false

export const shouldEnableSendActivationEmail = user => 
    user.status === 'STAGED' && !isNewUser(user) && !isPartiallyActive(user)

export const shouldEnableResetPassword = user => user.status !== 'STAGED' &&
   user.status !== 'PROVISIONED' && !isNewUser(user)

export const shouldEnableSendReActivationEmail = user => user.status === 'PROVISIONED'
 || isNewUser(user) || (user.status === 'STAGED' && isPartiallyActive(user))

 export const shouldEnableResetMultiFactor = user => user.status !== 'SUSPENDED' && 
 user.status !== 'DEACTIVATED' && !isNewUser(user) && !isRestrictedTenant()

 export const getLastLogin = user => {
    if(user?.meta?.lastLogin === null) {
        return "Null";
    }
    return user?.meta?.lastLogin;
 }

export const getFirstLetterOfLastName = (user) => {
    const lastName = getLastName(user)
    
    if (lastName === '') {
        return lastName
    }

    const resultArr = lastName.split('')

    return `${resultArr[0].toUpperCase()}.`
}
